import { Api } from 'utils';

class CategoryService {

    static admin = {
        get: async (params?: any) => Api.createResponse('admin/home/categories',params),
        create: async (params?: any) => Api.createResponse('admin/home/categories/create',params),
        update: async (params?: any) => Api.createResponse('admin/home/categories/update',params),
        delete: async (params?: any) => Api.createResponse('admin/home/categories/delete',params),
        suspend: async (params?: any) => Api.createResponse('admin/home/categories/suspend',params)
    }

}

export default CategoryService;